import jFlowNew from '@/views/flow-rule/flow/jFlowNew';
import jFlowCreateType2 from '@/views/flow-rule/flow/create/jFlowCreateType2';
import jFlowEditType2 from '@/views/flow-rule/flow/edit/jFlowEditType2';
import jRulesNew from '@/views/flow-rule/rules/jRulesNew';
import jIndexFR from '@/views/flow-rule/index';
import auth from '@/middleware/auth';
import admin from '@/middleware/admin';
import jRulesUpdate from '@/views/flow-rule/rules/jRulesUpdate';
import jFlowtest from '@/views/flow-rule/flow/jFlowUpdate';
import jEditFlowSLA from '@/views/flow-rule/flow/flow-sla/detail/jDetailFlowSLA';
import jCreateFlowSLA from '@/views/flow-rule/flow/flow-sla/create/jCreateFlowSLA';

export default [
  {
    path: '/flow/update-by-division/:id',
    name: 'Edit Flow Type 2',
    component: jFlowEditType2,
    meta: {
      middleware: [auth, admin],
      title: 'Edit Flow Type 2',
    },
  },
  {
    path: '/flow/new-by-division',
    name: 'New Flow Type 2',
    component: jFlowCreateType2,
    meta: {
      middleware: [auth, admin],
      title: 'Create Flow By Division',
    },
  },
  {
    path: '/flow/new',
    name: 'New Flow',
    component: jFlowNew,
    meta: {
      middleware: [auth, admin],
      title: 'Create Flow',
    },
  },
  {
    path: '/flow/update/:id',
    name: 'Update Flow',
    component: jFlowtest,
    meta: {
      middleware: [auth, admin],
      title: 'Update Flow',
    },
  },
  {
    path: '/rules/new',
    name: 'New Rules',
    component: jRulesNew,
    meta: {
      middleware: [auth, admin],
      title: 'Create Rule',
    },
  },
  {
    path: '/rules/update/:id',
    name: 'Update Rules',
    component: jRulesUpdate,
    meta: {
      middleware: [auth, admin],
      title: 'Update Rule',
    },
  },
  {
    path: '/flows',
    name: 'Flows',
    component: jIndexFR,
    meta: {
      middleware: [auth, admin],
      title: 'Flows and Rules',
      layout: 'jSettingWrapper',
    },
    children: [
      {
        path: '/flows/sla/edit/:id',
        name: 'Edit Flow SLA',
        component: jEditFlowSLA,
        meta: {
          middleware: [auth, admin],
          title: 'Edit Flow SLA',
        },
      },
      {
        path: '/flows/sla/create',
        name: 'Create Flow SLA',
        component: jCreateFlowSLA,
        meta: {
          middleware: [auth, admin],
          title: 'Create Flow SLA',
        },
      },
    ],
  },
];

// jojoflows.map((dataPath) => {
//   const eachData = dataPath;
//   eachData.meta.middleware = [auth, admin];
//   return eachData;
// });


// export default jojoflows;



// WEBPACK FOOTER //
// ./src/router/jRouterFlowRules.js